import clsx from "clsx";
import { Link, useLocation } from "react-router-dom";
import { TOffSiteOrderType, TOnSiteOrderType } from "src/app/types/orders/order";
import { SimpleGridReset } from "../grid/SimpleGridReset";
import AddBoostToOrderModelWithButton from "src/app/containers/AddBoostToOrderModelWithButton/AddBoostToOrderModelWithButtonContainer";
import { TSelectedRows } from "src/app/containers/AddBoostToOrderModel/AddBoostToOrderModelContainer";
import { useIntl } from "react-intl";
import React from "react";
import { KTSVG } from "src/_metronic/helpers/components/KTSVG";
import { toAbsoluteUrl } from "src/_metronic/helpers";
import SVG from "react-inlinesvg";
import { useAuth } from "src/app/utils/useAuth";
import { checkPathRequirement } from "src/app/routing/RouteRequirementHandler";
/* import { MissingOrderContainer } from "src/app/containers";
 */
const OrderTypeMenu = (props: {
    basePath: string;
    gridRef?: React.RefObject<any>;
    moneySiteId?: number;
    addSeparators?: Array<Number>;
    siteOrderType: Array<TOnSiteOrderType | TOffSiteOrderType>;
    selectedRows?: Array<TSelectedRows> | null;
    onClick?: () => void;
    isVisible?: boolean;
}) => {
    const {
        basePath,
        gridRef,
        selectedRows,
        siteOrderType,
        addSeparators = [],
        /* moneySiteId, */
        onClick,
        isVisible,
    } = props;

    const toggleVisibility = () => {
        onClick?.();
    };

    const { formatMessage } = useIntl();
    const { pathname } = useLocation();
    const { currentUser } = useAuth();

    const resetGrid = () => {
        if (gridRef?.current?.api) {
            gridRef.current.api.setFilterModel({});
            gridRef.current.columnApi.resetColumnState();
        }
    };

    return (
        <div>
            <div
                className={`d-flex align-items-center justify-content-between ${
                    isVisible ? "mt-4" : "mt-0"
                }`}
                style={{
                    background: "#1e1e2d",
                    margin: "0px",
                }}
            >
                <ul className="breadcrumb breadcrumb-links breadcrumb-separatorless fw-bold-800 fs-7 my-1 ms-4">
                    {siteOrderType.map((item, index) => {
                        const inCurrentPath = pathname.includes(item.toLowerCase());
                        const hasAccess = checkPathRequirement(
                            `${basePath}${item.toLowerCase()}`,
                            currentUser.role
                        );
                        if (!hasAccess) return <></>;
                        return (
                            <React.Fragment key={index}>
                                <li className="breadcrumb-item ">
                                    <Link
                                        className={clsx("text-hover-primary", {
                                            "link-active": inCurrentPath,
                                            "text-white": !inCurrentPath,
                                        })}
                                        to={`${basePath}${item.toLowerCase()}`}
                                    >
                                        {formatMessage({ id: `common.siteOrderType.${item}` })}
                                    </Link>
                                </li>
                                {addSeparators.includes(index) && (
                                    <div
                                        style={{
                                            width: "2px",
                                            height: "32px",
                                            backgroundColor: "var(--kt-primary)",
                                            marginRight: "8px",
                                        }}
                                    />
                                )}
                            </React.Fragment>
                        );
                    })}
                </ul>
                <div>
                    <AddBoostToOrderModelWithButton selectedRows={selectedRows} />
                    {/*moneySiteId && <MissingOrderContainer moneySiteId={moneySiteId} />*/}

                    <Link
                        className={clsx("me-5 text-hover-primary", {
                            "link-active": pathname.includes("history"),
                            "text-white": !pathname.includes("history"),
                        })}
                        to={`${basePath}history`}
                    >
                        <SVG
                            className={
                                pathname.includes("history") ? "svg-icon-primary" : "svg-icon-white"
                            }
                            width={32}
                            src={toAbsoluteUrl(`/media/icons/duotune/ecommerce/ecm008.svg`)}
                        />
                    </Link>

                    <div
                        className="btn btn-icon w-auto px-0 btn-active-color-primary"
                        onClick={toggleVisibility}
                    >
                        <KTSVG
                            path={"/media/icons/duotune/arrows/arr081.svg"}
                            className={`svg-icon-1 ${isVisible ? "" : "rotate-180deg"}`}
                        />
                    </div>
                    <SimpleGridReset onChange={resetGrid} />
                </div>
            </div>
        </div>
    );
};

export default OrderTypeMenu;
